import React from "react";

const UserGuide = () => {
  return <div>Uputstvo</div>;
};

export default UserGuide;
